import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { refSagaActions } from "../../Administration/ReferenceInfoManagement";
import { agencySagaActions } from "../../Administration/AgencyManagement";
import { serviceSagaActions } from "../../Administration/ServiceManagement";
import { serviceItemSagaActions } from "../../Administration/ServiceItemManagement";
import { provinceSagaActions } from "../../Administration/ProvinceInfoManagement";

import { Button, Form, Col, Card, Collapse } from "react-bootstrap";
import { CaretDownFill, CaretUpFill, Search, Calendar4Week } from "react-bootstrap-icons";
import ReactDatePicker from "react-datepicker";
import { Formik } from "formik";
import { format } from "date-fns";
import * as Yup from "yup";

import styles from "../css/receiptTracking.module.css";
import "react-datepicker/dist/react-datepicker.css";


const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd-MMMM-yyyy");

//search form schema definition
const searchFormSchema = Yup.object().shape({
  prioritySearch: Yup.object({}),
  receiptNumber: Yup.string()
    .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt No.")
    .min(13, "*Incorrect length")
    .max(13, "*Incorrect length")
    .when('customerMobile', {
      is: value => !value,
      then: Yup.string()
        .matches(/^[Ee]{1}[Rr]{1}[Gg]{1}[A-Za-z0-9]{10}$/, "*Invalid Receipt No.")
        .required("*Enter a Receipt No.")
        .min(13, "*Incorrect length")
        .max(13, "*Incorrect length"),
      otherwise: Yup.string()
    }),
  customerFirstName: Yup.string()
  .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character"),
  customerLastName: Yup.string()
    .matches(/^[a-zA-Z'\s]{1,20}$/, "*Invalid character"),
  customerMobile: Yup.string()
    // .matches(/^[7+][0-9]{7}$/, "*Invalid Mobile No.")
    .matches(/^[6]{1}[7]{1}[5]{1}[78]{1}[0-9]{7}$/, "*Mobile No. format: 675xxxxxxxx")
    .when('receiptNumber', {
      is: value => !value,
      // then: Yup.string().matches(/^[7+][0-9]{7}$/, "*Invalid Mobile No.").required("*Enter a Mobile No."),
      then: Yup.string().matches(/^[6]{1}[7]{1}[5]{1}[78]{1}[0-9]{7}$/, "*Mobile No. format: 675xxxxxxxx").required("*Enter a Mobile No."),
      otherwise: Yup.string()
    }),
  receiptStatus: Yup.string()
    .max(3, "*Invalid"),
  dept: Yup.string()
    .max(4, "*Invalid"),
  province: Yup.string()
  .max(3, "*Invalid"),
  serviceType: Yup.string()
    .max(3, "*Invalid"),
  fromDate: Yup.date()
    .max(presentDate, `Date must be earlier than the ${formatPresentDate}`),
  toDate: Yup.date()
    .min(Yup.ref('fromDate'), "*'Date To' must be after the 'Date From'")
    .max(presentDate, `Date must be earlier than the ${formatPresentDate}`)
}, ['receiptNumber', 'customerMobile']);


export function ReceiptTrackingSearchForm(props) {

  const dispatch = useDispatch();
  const { reference, agency, services, serviceItem, province } = useSelector(state => state);  

  const { allReferences, referenceKinds } = reference;
  const { agencies } = agency;
  const { serviceTypes } = services;
  const { serviceItems } = serviceItem;
  const { provinces } = province;

  const searchFormRef = useRef();

  const [selectedDeptServices, setSelectedDeptServices] = useState([]);
  const [receiptStatuses, setReceiptStatuses] = useState([]);
  const [serviceItemList, setServiceItemList] = useState([]);
  const [showSearch, setShowSearch] = useState(true);

  useEffect(() => {
    if(referenceKinds.length > 1){
      let receiptStatusKind = referenceKinds.find((kind) => (kind.code === "RECEIPT_STATUS"));
      let recStats = allReferences.filter((ref) => (ref.kindId === receiptStatusKind.id && ref.description !== "Invalid"));
      setReceiptStatuses(recStats);
    }
  }, [referenceKinds, allReferences]);

  useEffect(() => {

    dispatch(refSagaActions.fetchAllReferences());
    dispatch(agencySagaActions.fetchAgencies());
    dispatch(serviceSagaActions.fetchServices());
    dispatch(serviceItemSagaActions.fetchServiceItems());
    dispatch(provinceSagaActions.fetchProvinces());

  },[dispatch]);
  

  const queryParamsInitialState = { 
    fromDate:"", 
    toDate:"", 
    receiptNumber:"", 
    receiptStatus:"", 
    dept:"", 
    serviceType:"",
    customerFirstName: "",
    customerLastName: "",
    customerMobile:"",
    serviceItem: "",
    province: ""
  };

  const filterServices = (deptId) => {
    let serviceList = serviceTypes.filter((serv) => (serv.department_id === Number(deptId)));
    setSelectedDeptServices(serviceList);
  };

  const filterServiceItems = (serviceTypeId) => {
    let serviceItemList = serviceItems.filter((item) => (item.service_id === Number(serviceTypeId)));
    setServiceItemList(serviceItemList);
  };

  const handleSearchReceiptReset = () => {
    searchFormRef.current.reset();
    let today = format(presentDate, "dd/MM/yyyy");
    props.onHandleFormReset({
      fromIssuedDate: today,
      toIssuedDate: today
    });
  };

  const handleSearchReceipt = (newQueryParams) => {
    props.onHandleSearchReceipt(newQueryParams);
  };

  return (
    <Card>
      <Card.Header>
        <span className="row">
          <span className="col d-flex align-items-center"> 
            <h4> <Search size={26}/> Search Reciept </h4> 
          </span>
          <span className="col">
            <span 
              className="p-0 m-0 d-flex justify-content-end"
            >
              { showSearch 
                ? <Button variant="light" onClick={() => {setShowSearch(false)}} > <CaretUpFill size={15} /> </Button>
                : <Button variant="light" onClick={() => {setShowSearch(true)}} > <CaretDownFill size={15} /> </Button>
              }
            </span>
          </span>
        </span>
      </Card.Header>
      <Collapse in={showSearch}>
        <Card.Body>
          <Formik
            initialValues={queryParamsInitialState}
            validationSchema={searchFormSchema}
            onSubmit={(values, {setSubmitting}) => {

              setSubmitting(true);
              let newQueryParams = { 
                fromIssuedDate: values.fromDate ? format(values.fromDate, "dd/MM/yyyy") : "", 
                toIssuedDate: values.toDate ? format(values.toDate, "dd/MM/yyyy") : "",
                receiptNumber: values.receiptNumber, 
                receiptStatusId: values.receiptStatus, 
                departmentId: values.dept, 
                serviceId: values.serviceType,
                customerFirstName: values.customerFirstName.trim(),
                customerLastName: values.customerLastName.trim(),
                mobileNumber: values.customerMobile,
                serviceItemId: values.serviceItem,
                provinceId: values.province
              };
              handleSearchReceipt(newQueryParams);
              setSubmitting(false);
            }}
          >
            {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, handleReset, setFieldValue, setFieldTouched }) => (
              
              <Form ref={searchFormRef} onSubmit={handleSubmit}>
                <Form.Row>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramReceiptNumber">
                      <Form.Label>Receipt No. : <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        name="receiptNumber"
                        placeholder="ERGxxxxxxxxxx" 
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.receiptNumber}
                        maxLength={13}
                        className={styles.formInput}
                        isInvalid={touched.receiptNumber && errors.receiptNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.receiptNumber}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramCustomerMobile">
                      <Form.Label>Customer Mobile No. : <span className="text-danger">*</span></Form.Label>
                      <Form.Control
                        name="customerMobile"
                        placeholder="675xxxxxxxx" 
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.customerMobile}
                        className={styles.formInput}
                        isInvalid={touched.customerMobile && errors.customerMobile}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customerMobile}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramProvince">
                      <Form.Label>Province:</Form.Label>
                      <Form.Control 
                        as="select"  
                        name="province"
                        onChange={handleChange}
                        onBlur={handleBlur} 
                        value={values.province}
                        className="form-select my-1 mr-sm-2"
                        isInvalid={touched.province && errors.province}
                        custom 
                      >
                        <option className={styles.options} value="" hidden>-- Select --</option>
                        {provinces.map((p, index) => (
                          <option className={styles.options} key={index} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.province}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramCustomerFirstName">
                      <Form.Label>Customer First Name:</Form.Label>
                      <Form.Control 
                        name="customerFirstName" 
                        placeholder="First Name" 
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.customerFirstName}
                        className={styles.formInput}
                        isInvalid={touched.customerFirstName && errors.customerFirstName} 
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customerFirstName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramCustomerLastName">
                      <Form.Label>Customer Last Name:</Form.Label>
                      <Form.Control 
                        name="customerLastName" 
                        placeholder="Last Name" 
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.customerLastName}
                        className={styles.formInput}
                        isInvalid={touched.customerLastName && errors.customerLastName} 
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.customerLastName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramReceiptStatus">
                      <Form.Label>Receipt Status:</Form.Label>
                      <Form.Control 
                        as="select" 
                        name="receiptStatus"
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.receiptStatus} 
                        className="form-select my-1 mr-sm-2"
                        isInvalid={touched.receiptStatus && errors.receiptStatus}
                        custom
                      >
                        <option className={styles.options} value="" hidden>-- Select --</option>
                        {receiptStatuses.map((s, index) => (
                          <option className={styles.options} key={index} value={s.id}>
                            {s.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.receiptStatus}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramDepartment">
                      <Form.Label>Department:</Form.Label>
                      <Form.Control 
                        as="select"  
                        name="dept"
                        onChange={(e) => {handleChange(e); filterServices(e.target.value)}}
                        onBlur={handleBlur} 
                        value={values.dept}
                        className="form-select my-1 mr-sm-2"
                        isInvalid={touched.dept && errors.dept}
                        custom 
                      >
                        <option className={styles.options} value="" hidden>-- Select --</option>
                        {agencies.map((a, index) => (
                          <option className={styles.options} key={index} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.dept}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramServiceType">
                      <Form.Label>Service Type:</Form.Label>
                      <Form.Control 
                        as="select"  
                        name="serviceType"
                        onChange={(e) => {handleChange(e); filterServiceItems(e.target.value); setFieldValue("serviceItem", ""); }} 
                        onBlur={handleBlur} 
                        value={values.serviceType}
                        className="form-select my-1 mr-sm-2"
                        custom
                        isInvalid={touched.serviceType && errors.serviceType}
                        //disabled when a department/agency is not selected, this will reduce the length of services displayed
                        disabled={ (values.dept === undefined || values.dept === "" || values.dept === null) } 
                      >
                        <option className={styles.options} value="" hidden>-- Select --</option>
                        {selectedDeptServices.map((type, index) => (
                          <option key={index} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.serviceType}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg md={12} sm={12}>
                    <Form.Group controlId="paramServiceItem">
                      <Form.Label>Service Item:</Form.Label>
                      <Form.Control 
                        as="select" 
                        name="serviceItem"
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                        value={values.serviceItem} 
                        className="form-select my-1 mr-sm-2"
                        custom
                        isInvalid={touched.serviceItem && errors.serviceItem}
                        disabled={ (values.serviceType === undefined || values.serviceType === "" || values.serviceType === null) } 
                      >
                        <option className={styles.options} value="" hidden>-- Select --</option>
                        {serviceItemList.map((i, index) => (
                          <option className={styles.options} key={index} value={i.id}>
                            {i.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.serviceItem}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="paramFromDate">
                      <Form.Label> <Calendar4Week size={15} /> {" "} From:</Form.Label>
                      <ReactDatePicker
                        autoComplete="off"
                        className={touched.fromDate && errors.fromDate ? "form-control border border-danger" : "form-control"}
                        name="fromDate"
                        dateFormat="dd-MMMM-yyyy"
                        dateFormatCalendar="MMMM yyyy"
                        placeholderText={formatPresentDate}
                        selected={values.fromDate}
                        value={values.fromDate}
                        onChange={ (dt) => {
                          setFieldTouched("fromDate", true, true);
                          let date = dt;
                          if(date === null || date === undefined){
                            date = ""
                          }
                          let changes = { target: { name: "fromDate", value: date } };
                          handleChange(changes);  
                        }}
                        onBlur={handleBlur}
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        minDate={new Date("06/01/2021")}
                        maxDate={presentDate}
                        todayButton="Today"
                      />
                      { touched.fromDate && errors.fromDate ? <div style={{ color: "red" }}> {errors.fromDate} </div> : null }
                    </Form.Group>
                  </Col>
                  <Col lg={4} md={12} sm={12}>
                    <Form.Group controlId="paramToDate">
                      <Form.Label> <Calendar4Week size={15} /> {" "} To:</Form.Label>
                      <ReactDatePicker
                        autoComplete="off"
                        className={touched.toDate && errors.toDate ? "form-control border border-danger" : "form-control"}
                        name="toDate"
                        dateFormat="dd-MMMM-yyyy"
                        dateFormatCalendar="MMMM yyyy"
                        placeholderText={formatPresentDate}
                        selected={values.toDate}
                        value={values.toDate}
                        onChange={ (dt) => {
                          setFieldTouched("toDate", true, true);
                          let date = dt;
                          if(date === null || date === undefined){
                            date = ""
                          }
                          let changes = { target: { name: "toDate", value: date } };
                          handleChange(changes);  
                        }}
                        onBlur={handleBlur}
                        showMonthYearDropdown
                        scrollableMonthYearDropdown
                        minDate={new Date("06/01/2021")}
                        maxDate={presentDate}
                        todayButton="Today"
                      />
                      { touched.toDate && errors.toDate ? <div style={{ color: "red" }}> {errors.toDate} </div> : null }
                    </Form.Group>
                  </Col>
                </Form.Row>
                <Button type="submit" variant="primary" disabled={isSubmitting}>
                  <Search /> {" "} Search
                </Button>{" "}
                <Button onClick={()=> {handleSearchReceiptReset(); handleReset()}} variant="secondary">
                  Reset
                </Button>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Collapse>
    </Card>
  );
};
